export enum BookingCounterType {
	Delayed = 'booking_delayed',
	Unconfirmed = 'booking_unconfirmed',
}
